import styled from 'styled-components';
import { COLORS, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

export const ContentPadding = styled.div`
  position: relative;
  padding-bottom: ${SIZING.unit(9.5)};
  @media ${device.tablet} {
    padding-bottom: ${SIZING.unit(11.125)};
  }
  @media ${device.laptop} {
    padding-bottom: 0;
  }
`;

export const StyledWrapper = styled.div`
  .embla {
    position: relative;
    --slide-height: 19rem;
    --slide-spacing: 32px;
    --slide-size: 371px;
    @media ${device.laptop} {
      --slide-spacing: 44px;
      --slide-size: 783px;
    }
    @media ${device.laptopL} {
      --slide-spacing: 44px;
      --slide-size: 885px;
    }
  }
  .embla-alpha {
    display: flex;
    flex-direction: column;

    .arrow-controller {
      order: 3;
      display: flex;
      gap: 130px;
      align-items: center;
      justify-content: flex-end;
      margin-top: 16px;
      margin-bottom: 44px;

      @media (min-width: 1024px) {
        display: none;
      }

      .embla__arrow-group-alpha {
        justify-content: flex-end;
        display: flex;
        width: 100%;
      }
    }
  }

  .embla__viewport {
    overflow: hidden;
    position: relative;
  }
  .embla__container {
    backface-visibility: hidden;
    display: flex;
    touch-action: pan-y pinch-zoom;
    // margin-left: calc(var(--slide-spacing) * 1);
  }
  .embla__slide {
    flex: 0 0 var(--slide-size);
    height: 641px;
    @media ${device.laptop} {
      height: 367px;
    }
    min-width: 0;
    padding-right: var(--slide-spacing);
  }

  .embla__slide-alpha {
    flex: auto;
    height: auto;
    min-width: auto;
    align-self: stretch;
    padding-right: var(--Sys-Space-Fixed-200, 16px);

    @media ${device.laptop} {
      height: auto;
    }
  }
`;

export const BonusCTA = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  :hover,
  :focus {
    .tag-label {
      background-color: ${COLORS.grey15};
    }
  }
`;

export const ArrowGroup = styled.div`
  justify-content: end;
`;
